// unit: form
import f from "../../funcs";
import _ from "underscore";
import Backbone from "backbone";
import langDictionary from "../lang/init";


/**
     * Модель строки любой таблицы,
     * при работе с rowsStorage возвращаются не массив "строк" (rows),
     * а массив из экземпляров RowModel
     * @constructs RowModel
     * @extends Backbone.Model
     */
const RowModel = Backbone.Model.extend("RowModel", {

    // других способов организовать this.prepare и синхронизацию с унаследванными моделями непридумал,
    // поэтому переопределяю стандартный set
    set(key, val, options) {
        let attr;
        let attrs;
        let unset;
        let changes;
        let silent;
        let changing;
        let prev;
        let current;
        if ( key == null ) return this;

        // Handle both `"key", value` and `{key: value}` -style arguments.
        if ( typeof key === "object" ) {
            attrs = key;
            options = val;
        } else {
            (attrs = {})[key] = val;
        }

        if ( !options ) {
            options = {};
        }

        if ( options.storage ) {
            this.storage = options.storage;
        }

        // Run validation.
        if ( !this._validate(attrs, options) ) return false;

        // Extract attributes and options.
        unset = options.unset;
        silent = options.silent;
        changes = [];
        changing = this._changing;
        this._changing = true;

        if ( !changing ) {
            this._previousAttributes = _.clone(this.attributes);
            this.changed = {};
        }
        current = this.attributes, prev = this._previousAttributes;

        // Check for changes of `id`.
        if ( this.idAttribute in attrs ) this.id = attrs[this.idAttribute];

        // For each `set` attribute, update or delete the current value.
        for (attr in attrs) {
            val = attrs[attr];
            if ( !_.isEqual(current[attr], val) ) changes.push(attr);
            if ( !_.isEqual(prev[attr], val) ) {
                this.changed[attr] = val;
            } else {
                delete this.changed[attr];
            }
            unset ? delete current[attr] : current[attr] = val;
        }

        // clear cache
        this.texts = null;
        this.sortData = null;
        // -------------

        // Trigger all relevant attribute changes.
        if ( !silent ) {
            if ( changes.length ) this._pending = true;
            for (let i = 0, l = changes.length; i < l; i++) {
                this.trigger("change:" + changes[i], this, current[changes[i]], options);
            }
        }

        // You might be wondering why there's a `while` loop here. Changes can
        // be recursively nested within `"change"` events.
        if ( changing ) return this;
        if ( !silent ) {
            while (this._pending) {
                this._pending = false;
                this.trigger("change", this, options);
            }
        }
        this._pending = false;
        this._changing = false;
        return this;
    },

    /**
         * Преобразование в объект подготовленный для сортировки
         * @return {Object} ключ это поле, значение специально подготовленное значение
         * @memberof RowModel.prototype
         */
    parse2sortData() {
        let sortData = {};
        let columns = this.storage.columns;

        if ( !columns ) {
            return sortData;
        }

        columns.each(function(column) {
            let key = column.get("key");
            let type = column.get("type");
            let value = this.get(key);
            let outValue;

            if ( key == "ID" ) {
                value = this.id || this.get("ID") || this.get("id");
            }
            // =====

            if ( type == "number" || type == "checkbox" || type == "minute" || type == "time" ) {
                // +null => 0
                // +"1" => 1
                // +"0" => 0
                // +("null"+"") => NaN
                // +(1+"") => 1
                if ( f.isNumber(+(value + "")) ) {
                    outValue = +value;
                } else {
                    outValue = 0;
                }
            } else if ( type == "text" || type == "html" || type == "gridlist" ) {
                outValue = value + "";
            } else if ( type == "currency" ) {
                outValue = Math.round(value); // TAG: currency10000
            } else if ( type == "date" || type == "datetime" ) {
                if ( !value ) {
                    outValue = 0;
                } else {
                    outValue = +f.parseDate(value).date;
                }
            } else if ( type == "querytitle" ) {
                outValue = langDictionary.getTableName(value);
            }

            sortData[key] = outValue;
        }.bind(this));

        return sortData;
    },

    /**
         * Преобразование в объект строк
         * @return {Object} ключ это поле, значение это строка,
         * которую можно отрисовать
         * @memberof RowModel.prototype
         */
    parse2texts() {
        let texts = {};
        let columns = this.storage.columns;

        if ( !columns ) {
            return null;
        }

        columns.each(function(column) {
            let key = column.get("key");
            let type = column.get("type");
            let value = this.get(key);
            let text = "";
            let info = column.get("info");

            if ( type == "number" ) {
                if ( f.isNumber(+value) && value != null ) {
                    if ( info && f.isNumber(info.round) ) {
                        // rating is number, but he must be rounded to 2
                        value = Math.round(value * Math.pow(10, info.round)) / Math.pow(10, info.round);
                    }
                    text = +value + "";
                } else {
                    text = "";
                }
                if ( !text && info.nullAsZero ) {
                    text = "0";
                }
            } else if ( type == "currency" ) {
                if ( value == null ) {
                    text = "";
                } else {
                    value = f.round2(value, 4); // TAG: currency10000
                    if ( column.get("float") == "auto" ) {
                        text = f.currencySpaces(value, { float: "auto" });
                    } else {
                        text = f.currencySpaces(value);
                    }
                }
                if ( !text && info.nullAsZero ) {
                    text = "0.00";
                }
            } else if ( type == "html" ) {
                text = f.stripTags((value || "") + "");
            } else if ( type == "date" ) {
                if ( !value ) {
                    text = "";
                } else if ( info.is_utc_time ) {
                    // приводим к utc времени
                    text = f.timestamp2userdate(+f.parseDate(value).date + f.parseDate(value).date.getTimezoneOffset() * 60 * 1000).split(" ")[0];
                } else {
                    text = f.timestamp2userdate(f.parseDate(value).date).split(" ")[0];
                }
            } else if ( type == "fileurl" ) {
                if ( !f.isString(value) ) {
                    text = "";
                } else {
                    text = value.replace(/\\/g, "/");
                }
            } else if ( type == "datetime" ) {
                if ( !value ) {
                    text = "";
                } else if ( info.is_utc_time ) {
                    // приводим к utc времени
                    text = f.timestamp2userdate(+f.parseDate(value).date + f.parseDate(value).date.getTimezoneOffset() * 60 * 1000);
                } else {
                    text = f.timestamp2userdate(f.parseDate(value).date);
                }
            } else if ( type == "checkbox" ) {
                if ( value == null ) { // null, undefined
                    text = "";
                } else if ( value == langDictionary.get("Yes") || value == langDictionary.get("No") ) {
                    text = value;
                } else if ( value == "1" ) {
                    text = langDictionary.get("Yes");
                } else if ( value == "0" ) {
                    text = langDictionary.get("No");
                }
            } else if ( type == "json" ) {
                if ( f.isString(value) ) {
                    text = value;
                    if ( value === "" ) {
                        this.attributes[key] = null;
                    } else {
                        try {
                            this.attributes[key] = JSON.parse(value);
                        } catch (e) {
                            console.log(e);
                        }
                    }
                } else if ( f.isObject(value) ) {
                    try {
                        text = JSON.stringify(value);
                    } catch (e) {
                        console.log(e);
                    }
                } else {
                    text = "";
                }
            } else if ( type == "querytitle" ) {
                text = langDictionary.getTableName(String(value || ""));
            }
            else if ( type == "minute" ) {
                if ( value == null ) { // null or undefined
                    text = "";
                } else {
                    text = f.minute2text(value);
                }
            }
            else if ( type == "time" ) {
                if ( value == null ) {
                    text = "";
                } else {
                    text = f.minutes2hoursMinutes(value);
                }
            }
            else {
                text = String(value || "");

                if ( info && info.emoji ) {
                    text = f.stripTags(text);
                }
                if ( info && info.hideEOL ) {
                    text = text.replace(/[\n\r]+/g, " ");
                }
            }

            // костылек
            if ( key == "ID" ) {
                text = this.get("id") + "";
                texts.id = text;
                texts._id = text; // treeData
            }

            texts[key] = text;
        }.bind(this));

        // Если уж добавили module в model я хочу нормально по ней фильтровать
        const moduleNames = Object.keys(system.modules);

        if ( moduleNames && moduleNames.length ) {
            texts.module = moduleNames[0] ? moduleNames[0] : "Dev";
        }

        return texts;
    },

    /**
         * Получить копию текстовых данных.
         * В отличии от parse2texts, возвращается закэшированная копия
         * @return {Object} текстовые данные строки для отрисовки
         * @memberof RowModel.prototype
         */
    getTexts() {
        if ( !this.texts ) {
            this.texts = this.parse2texts();
        }
        return f.deepClone(this.texts);
    },

    /**
         * Получить копию данных для сортировки.
         * В отличии от parse2sortData, возвращается закэшированная копия
         * @return {Object} специальный объект, где данные подготовленны для вызова multiSort
         * @memberof RowModel.prototype
         */
    getSortData() {
        if ( !this.sortData ) {
            this.sortData = this.parse2sortData();
        }
        return f.deepClone(this.sortData);
    },

    mathSortWeight(sortElems, model) {
        if ( !this.sortData ) {
            this.sortData = this.parse2sortData();
        }
        let elem;
        let key;
        let vector;
        let a;
        let b;

        for (let i = 0, n = sortElems.length; i < n; i++) {
            elem = sortElems[i];
            key = elem.key;
            vector = elem.vector;

            a = this.sortData[key];
            if ( !model.sortData ) {
                model.sortData = model.parse2sortData();
            }
            b = model.sortData[key];

            if ( a != b ) {
                return a > b ? vector : -vector;
            }
        }

        return 0;
    },

    /**
         * Получить значение модели в виде строки для пользователя.
         * Значение проходит через обработку .parse2texts
         * @param  {String} key ключ значения, которое хотим получить
         * @return {String}
         */
    getText(key) {
        if ( !this.texts || !this.texts[key] ) {
            this.texts = this.parse2texts();
        }
        return this.texts && this.texts[key];
    },

    clone() {
        let clone = new RowModel({}, {
            storage: this.storage
        });
        if ( !this.sortData ) {
            this.sortData = this.parse2sortData();
        }
        if ( !this.sortData ) {
            this.sortData = this.parse2sortData();
        }
        clone.attributes = f.deepClone(this.attributes);
        clone.texts = f.deepClone(this.texts);
        clone.sortData = f.deepClone(this.sortData);

        clone.isClone = true; // не отправлять update
        clone.source = this; // знать своих отцов
        clone.id = this.id;

        return clone;
    },

    getType(key) {
        if ( !this.storage ) {
            return;
        }

        if ( !this.storage.columns ) {
            return;
        }

        let column = this.storage.columns.getByKey(key);

        if ( !column ) {
            return;
        }

        return column.get("type");
    },

    isVirtual() {
        return this.get("_is_virtual_model");
    }
});

export default RowModel;
